export default __webpack_public_path__ + "static/media/HCL.f83966fa.png";